import React, { ReactNode } from "react"

export const FlexContainerColumn = ({children}:{children?: ReactNode}) => {

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            {children}
        </div>
    )
}